import fetchWithSmimeHeaders from './fetchWithSmimeHeaders';
import SmimeCustomError from '../utils/SmimeCustomError';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';

/**
 * This function fetches the S/MIME p7m file given the url
 * @param url URL to fetch S/MIME p7m file
 */
const fetchSmimeDataPackage = async (url: string): Promise<string> => {
    const fetchP7MDatapoint = new PerformanceDatapoint('GetItemAttachmentPackage', {
        isCore: true,
    });
    try {
        const data = await fetchWithSmimeHeaders(url);
        fetchP7MDatapoint.end();
        return data;
    } catch (error) {
        fetchP7MDatapoint.endWithError(DatapointStatus.ServerError, error);
        throw new SmimeCustomError(error.message, SmimeErrorStateEnum.CannotFetchDataPackage);
    }
};

export default fetchSmimeDataPackage;
